/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'

interface ContextProps {
  focusedDate: Date | null
  isDateBlocked: (date: Date) => boolean
  isDateFocused: (date: Date) => boolean
  isDateHovered: (date: Date) => boolean
  isDateSelected: (date: Date) => boolean
  isFirstOrLastSelectedDate: (date: Date) => boolean
  onDateFocus: (date: Date) => void
  onDateHover: (date: Date) => void
  onDateSelect: (date: Date) => void
}

export const DatePickerContext = React.createContext<ContextProps>({
  focusedDate: null,
  isDateBlocked: () => false,
  isDateFocused: () => false,
  isDateHovered: () => false,
  isDateSelected: () => false,
  isFirstOrLastSelectedDate: () => false,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {},
})
